//列表
export const read={label:'Read'};
export const unread={label:'Unread'};
export const messageTitle={label:'Message Title'};
export const receiver={label:'Receiver'};
export const sendUser={label:'Senduser'};
export const messageTime={label:'Message Time'};
export const important={label:'Important'};
export const startTime={label:'Start Time'};
export const endTime={label:'End Time'};
export const messageContent={label:'Message Content'};
export const userAccount={label:'user account'};
export const userName={label:'user name'};
export const activate={label:'activate'};
export const receivedMessage={label:'Received message'};
export const workflowSLAMessage={label:'Workflow SLA message'};
export const businessMessage={label:'Business message'};
export const personalMessage={label:'Personal message'};
export const systemNotification={label:'System notification'};
export const sentMessage={label:'Sent message'};
export const itemsPerPage={label:'/page'};
export const jumpTo={label:'Go to'};
export const page={label:'page'};

//按钮名称
export const messagesButton={label:'Messages:'};
export const allButton={label:'all'};
export const unreadButton={label:'unread'};
export const readButton={label:'read'};
export const importantButton={label:'important'};
export const cancelImportantButton={label:'cancel important'};
export const CapitalAllButton={label:'All'};
export const markReadButton={label:'Mark Read'};
export const markedAsButton={label:'Marked As'};
export const SendMessageButton={label:'Send A Message'};
export const exitButton={label:'Exit'};
export const searchButton={label:'search'};
export const clearButton={label:'clear'};
export const lowerExitButton={label:'exit'};
export const sendButton={label:'send'};
export const okButton={label:'ok'};

//标题、提示语
export const selectUser={label:'Please click the plus sign to select the user'};
export const messageConversation={label:'Message conversation'};
export const messageInquiry={label:'Message inquiry'};
export const SendAMessageButton={label:'Send a message'};
export const pleaseSelectUser={label:'Please select user'};
export const searchCondition={label:'search condition'};
export const queryUser={label:'query user:'};
export const message={label:'Message'};
















